<div class="wrapper">
    <div class="title" *ngIf="title">{{title}}</div>
    <ng-content></ng-content>
</div>
<ng-container *ngIf="link">
    <ion-button expand="full" color="primary" style="margin: 0;border-bottom-left-radius: 8px; border-bottom-right-radius: 8px; overflow: hidden ; font-size: 15px; font-weight: 500" [routerLink]="link">Mehr anzeigen</ion-button>
</ng-container>
